import { ImageGallery } from "./Imagegallery";
var GalleryList = [
    {
        name: "Trailers",
        images: [
            ImageGallery.trailers.HighBedTrailers[0].image,
            ImageGallery.trailers.SemiLowBedTrailers[0].image,
            ImageGallery.trailers.LowBedTrailers[0].image
        ],
        type: [
            {
                heading: "High Bed Trailers",
                images: ImageGallery.trailers.HighBedTrailers
            },
            {
                heading: "Semi Low Bed Trailer",
                images: ImageGallery.trailers.SemiLowBedTrailers
            },
            {
                heading: "Low Bed Trailer",
                images: ImageGallery.trailers.LowBedTrailers
            },
            {
                heading: "Pullers",
                images: ImageGallery.trailers.Pullers
            }
        ]
    },
    {
        name: "Cranes",
        images: [
            ImageGallery.cranes.AllTerrainCranes[0].image,
            ImageGallery.cranes.ChainMountedCrawlerMountedCranes[0].image,
            ImageGallery.cranes.ChainMountedCrawlerMountedCranes[1].image
        ],
        type: [
            {
                heading: "All Terrain Cranes",
                images: ImageGallery.cranes.AllTerrainCranes
            },
            {
                heading: "Chain Mounted Crawler Mounted Cranes",
                images: ImageGallery.cranes.ChainMountedCrawlerMountedCranes
            },
            {
                heading: "Excavators",
                images: ImageGallery.cranes.Excavators
            },
            {
                heading: "Farana Cranes",
                images: ImageGallery.cranes.FaranaCranes
            },
            {
                heading: "MK Cranes",
                images: ImageGallery.cranes.MKCranes
            },
            {
                heading: "Palfinger",
                images: ImageGallery.cranes.Palfinger
            },
            {
                heading: "Pick and Carry Cranes",
                images: ImageGallery.cranes.PickandCarryCranes
            },
            {
                heading: "Truck Cranes",
                images: ImageGallery.cranes.TruckCranes
            }
        ]
    },
    {
        name: "Axles",
        images: [
            ImageGallery.axles.Axles_with_ODC_Cargo[0].image,
            ImageGallery.axles.Axles_Joined_Laterally[0].image,
            ImageGallery.axles.Axles_with_Puller[0].image
        ],
        type: [
            {
                heading: "Axles with ODC Cargo",
                images: ImageGallery.axles.Axles_with_ODC_Cargo
            },
            {
                heading: "Axles with Puller",
                images: ImageGallery.axles.Axles_with_Puller
            },
            {
                heading: "Axles Joined Laterally",
                images: ImageGallery.axles.Axles_Joined_Laterally
            }
        ]
    },
    {
        name: "Forklifts & Manlifts",
        images: [
            ImageGallery.fork_man_lift.forklift[0].image,
            ImageGallery.fork_man_lift.forklift[1].image,
            ImageGallery.fork_man_lift.forklift[2].image
        ],
        type: [
            {
                heading: "Forklifts",
                images: ImageGallery.fork_man_lift.forklift
            },
            {
                heading: "Manlifts",
                images: ImageGallery.fork_man_lift.Manlifts
            },
        ]
    },
    {
        name: "Our Projects",
        images: [
            ImageGallery.others[0].image,
            ImageGallery.others[1].image,
            ImageGallery.others[2].image
        ],
        type: [
            {
                heading: "",
                images: ImageGallery.others
            }
        ]
    }
]

export default GalleryList;